export const VEHICLE_USAGE = [
  {
    id: 'pleasure',
    label: 'Pleasure'
  },
  {
    id: 'drive_less_than_15',
    label: 'Drive to work less than 15 miles'
  },
  {
    id: 'drive_more_than_15',
    label: 'Drive to work more than 15 miles'
  },
  {
    id: 'business',
    label: 'Business'
  },
  {
    id: 'farm',
    label: 'Farm'
  }
]

export const MI_RENTAL = {
  1: 'None',
  2: '$30 per day/ $900 max',
  3: '$40 per day/ $1,200 max'
}

export const NJ_RENTAL = {
  1: '$15 per day/ $450 max',
  2: '$30 per day/ $900 max',
  3: 'No'
}

export const VEHICLE_MILEGE = [
  {
    id: '1',
    label: '0 - 3,000'
  },
  {
    id: '2',
    label: '3,001 - 6,000'
  },
  {
    id: '3',
    label: '6,001 - 9,000'
  },
  {
    id: '4',
    label: '9,001 - 12,000'
  },
  {
    id: '5',
    label: '12,001 - 15,000'
  },
  {
    id: '6',
    label: '15,001 - 18,000'
  },
  {
    id: '7',
    label: '18,001 - 21,000'
  },
  {
    id: '8',
    label: '21,001 - 24,000'
  },
  {
    id: '9',
    label: '24,001 - 27,000'
  },
  {
    id: '10',
    label: '27,001 - 30,000'
  },
  {
    id: '11',
    label: '30,001 - 33,000'
  },
  {
    id: '12',
    label: '33,001 - 36,000'
  },
  {
    id: '13',
    label: '36,001 - 99,999'
  }
]

export const VEHICLE_OWNERSHIP = [
  {
    id: '1',
    label: 'Owned'
  },
  {
    id: '2',
    label: 'Leased'
  },
  {
    id: '3',
    label: 'Financed'
  }
]

export const STATE = [
  {
    id: 'MI',
    label: 'Michigan'
  },
  {
    id: 'NJ',
    label: 'New Jersey'
  },
  {
    id: 'PA',
    label: 'Pennsylvania'
  }
]

export const VEHICLE_COLLISION = [
  {
    id: '1',
    label: '$50'
  },
  {
    id: '2',
    label: '$100'
  },
  {
    id: '3',
    label: '$150'
  },
  {
    id: '4',
    label: '$200'
  },
  {
    id: '5',
    label: '$250'
  },
  {
    id: '6',
    label: '$500'
  },
  {
    id: '7',
    label: '$1000'
  },
  {
    id: '8',
    label: '$1500'
  },
  {
    id: '9',
    label: '$2000'
  },
  {
    id: '10',
    label: '$2500'
  }
]

export const VEHICLE_COLLISION_MI = [
  {
    id: '1',
    label: '$50'
  },
  {
    id: '2',
    label: '$100'
  },
  {
    id: '3',
    label: '$200'
  },
  {
    id: '4',
    label: '$250'
  },
  {
    id: '5',
    label: '$500'
  },
  {
    id: '6',
    label: '$1000'
  },
  {
    id: '7',
    label: '$1500'
  },
  {
    id: '8',
    label: '$2000'
  },
  {
    id: '9',
    label: '$2500'
  }
]

export const VEHICLE_COLLISION_NJ = [
  {
    id: '1',
    label: '$100'
  },
  {
    id: '2',
    label: '$150'
  },
  {
    id: '3',
    label: '$200'
  },
  {
    id: '4',
    label: '$250'
  },
  {
    id: '5',
    label: '$500'
  },
  {
    id: '6',
    label: '$750'
  },
  {
    id: '7',
    label: '$850'
  },
  {
    id: '8',
    label: '$1000'
  },
  {
    id: '9',
    label: '$1500'
  },
  {
    id: '10',
    label: '$2000'
  }
]

export const VEHICLE_COLLISION_PA = [
  {
    id: '1',
    label: '$50'
  },
  {
    id: '2',
    label: '$100'
  },
  {
    id: '3',
    label: '$200'
  },
  {
    id: '4',
    label: '$250'
  },
  {
    id: '5',
    label: '$500'
  },
  {
    id: '6',
    label: '$750'
  },
  {
    id: '7',
    label: '$1000'
  },
  {
    id: '8',
    label: '$1500'
  },
  {
    id: '9',
    label: '$2000'
  },
  {
    id: '10',
    label: '$2500'
  }
]

export const VEHICLE_COLLISION_TYPE = [
  {
    id: '1',
    label: 'Standard'
  },
  {
    id: '2',
    label: 'Limited'
  },
  {
    id: '3',
    label: 'Broadened'
  }
]

export const VEHICLE_COLLISION_DEDUCTIBLE = [
  {
    id: '1',
    label: '$100'
  },
  {
    id: '2',
    label: '$200'
  },
  {
    id: '3',
    label: '$250'
  },
  {
    id: '4',
    label: '$500'
  },
  {
    id: '5',
    label: '$1000'
  },
  {
    id: '6',
    label: '$1500'
  },
  {
    id: '7',
    label: '$2000'
  },
  {
    id: '8',
    label: '$2500'
  }
]

export const VEHICLE_COLLISION_DEDUCTIBLE_NJ = [
  {
    id: '1',
    label: '$100'
  },
  {
    id: '2',
    label: '$150'
  },
  {
    id: '3',
    label: '$200'
  },
  {
    id: '4',
    label: '$250'
  },
  {
    id: '5',
    label: '$500'
  },
  {
    id: '6',
    label: '$750'
  },
  {
    id: '7',
    label: '$850'
  },
  {
    id: '8',
    label: '$1000'
  },
  {
    id: '9',
    label: '$1500'
  },
  {
    id: '10',
    label: '$2000'
  }
]

export const VEHICLE_COLLISION_DEDUCTIBLE_PA = [
  {
    id: '1',
    label: '$100'
  },
  {
    id: '2',
    label: '$200'
  },
  {
    id: '3',
    label: '$250'
  },
  {
    id: '4',
    label: '$500'
  },
  {
    id: '5',
    label: '$750'
  },
  {
    id: '6',
    label: '$1000'
  },
  {
    id: '7',
    label: '$1500'
  },
  {
    id: '8',
    label: '$2000'
  },
  {
    id: '9',
    label: '$2500'
  }
]

export const VEHICLE_DAYS_USAGE = [
  {
    id: '1',
    label: '1 day per week'
  },
  {
    id: '2',
    label: '2 day per week'
  },
  {
    id: '3',
    label: '3 day per week'
  },
  {
    id: '4',
    label: '4 day per week'
  },
  {
    id: '5',
    label: '5 day per week'
  },
  {
    id: '6',
    label: '6 day per week'
  },
  {
    id: '7',
    label: '7 day per week'
  }
]
export const VEHICLE_DAYS_DRIVE_MILES = [
  {
    id: '1',
    label: 'Less than 3 miles one-way'
  },
  {
    id: '2',
    label: 'Less than 10 miles one-way'
  },
  {
    id: '3',
    label: '10 or more miles one-way'
  },
  {
    id: '4',
    label: 'Pleasure use only'
  },
  {
    id: '5',
    label: 'Business use (traveling sales rep, etc.)'
  },
  {
    id: '6',
    label: 'Farm use'
  }
]

export const OTHER_THAN_COLLISION_COVERAGE_MI =
  '"Other than Collision" (Comprehensive) covers your vehicle, and sometimes other vehicles you may be driving, for losses resulting from incidents other than collision. For example, "Other than Collision" (Comprehensive) insurance covers damage to your car if it is stolen, or damaged by flood, fire, or animals. It pays to fix your vehicle less the deductible you choose. To keep your premiums low, select as high a deductible as you feel comfortable paying out of pocket. Coverage is limited to the terms and conditions contained in the policy.'
export const COLLISION_COVERAGE_DAMAGE_MI =
  'Collision covers damage to your car when your car hits, or is hit by, another vehicle, or other object. This coverage pays to fix your vehicle less the deductible you choose. To keep your premiums low, select as large a deductible as you feel comfortable paying out of pocket. Coverage is limited to the terms and conditions contained in the policy.'
export const RENTAL_REIMBURSEMENT_MI =
  "Rental Reimbursement pays for the cost of a rental car if you can't drive the insured vehicle due to theft or damage from an accident. Extended Transportation coverage cannot be purchased unless the car is covered under 'Other than Collision' (Comprehensive) coverage. Coverage is limited to the terms and conditions contained in the policy."
export const COLLISION_TYPE = [
  'Broad Collision: Pays for damages to your vehicle that was damaged regardless of fault, with a deductible that applies only if you are more than 50% at fault.',
  'Standard Collision: Pays for damages to your vehicle that was caused regardless of fault, with a deductible that always applies.',
  'Limited Collision: Pays for damage to your vehicle if you are less than 50% at fault for an accident. If you are 50% or more at fault, Collision coverage for this option will not apply to repair your vehicle.'
]

export const ADD_VEHICLE_MI_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  vehicleInfo: {
    vin: 'VIN',
    year: 'YEAR',
    make: 'MAKE',
    model: 'MODEL',
    purchaseDate: 'Vehicle Purchased Date',
    stateRegistered: 'Vehicle Registered State',
    registeredPersonFirstName: 'Vehicle Registered First Name',
    registeredPersonLastName: 'Vehicle Registered Last Name',
    vehicleUsage: 'How will the vehicle be used',
    annualMileage: 'Estimated annual mileage',
    vehicleOwnership: 'Is this vehicle owned/leased/financed',
    isVehicleWithCoOwnership: 'Is there a Co-Owner/Co-Buyer/Co-Lessee',
    nameOfBank: 'Name of Bank/Leasing Company',
    coOwnershipPersonFirstName: 'Co-Owner/Co-Buyer/Co-Lessee First Name',
    coOwnershipPersonLastName: 'Co-Owner/Co-Buyer/Co-Lessee Last Name',
    otherCollisionCoverage: 'Other than Collision (Comprehensive) coverage',
    otherCollisionDeductible: 'Other than Collision (Comprehensive) deductible',
    collisionCoverage: 'Collision coverage',
    collisionType: 'Collision type',
    collisionCoverageDeductible: 'Collision coverage deductible',
    rentalReimbursement: 'Rental Reimbursement',
    isVehiclePrimarilyKeptOvernight: 'Is this vehicle primarily kept overnight at the policy address',
    overnightVehicleAddress: {
      streetAddress: 'Street Address',
      apt: 'Apartment#',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code'
    }
  },
  isBusinessPurpose: 'Is your vehicle being used for business purposes',
  reason: 'Explanation for vehicle being used for business purposes',
  effectDate: 'What date would you like this change to go into effect?'
}

export const ADD_VEHICLE_NJ_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  vehicleInfo: {
    vin: 'VIN',
    year: 'YEAR',
    make: 'MAKE',
    model: 'MODEL',
    purchaseDate: 'Vehicle Purchased Date',
    stateRegistered: 'Vehicle Registered State',
    registeredPersonFirstName: 'Vehicle Registered First Name',
    registeredPersonLastName: 'Vehicle Registered Last Name',
    vehicleOwnership: 'Is this vehicle owned/leased/financed',
    noOfDaysUsed: 'No of days per week this vehicle is used to drive to work, school or public transportation site',
    isVehicleWithCoOwnership: 'Is there a Co-Owner/Co-Buyer/Co-Lessee',
    nameOfBank: 'Name of Bank/Leasing Company',
    oneWayMiles: 'One-way miles',
    coOwnershipPersonFirstName: 'Co-Owner/Co-Buyer/Co-Lessee First Name',
    coOwnershipPersonLastName: 'Co-Owner/Co-Buyer/Co-Lessee Last Name',
    otherCollisionCoverage: 'Other than Collision (Comprehensive) coverage',
    otherCollisionDeductible: 'Other than Collision (Comprehensive) deductible',
    collisionCoverage: 'Collision coverage',
    collisionCoverageDeductible: 'Collision coverage deductible',
    rentalReimbursementCoverage: 'Rental Reimbursement coverage',
    isVehiclePrimarilyKeptOvernight: 'Is this vehicle primarily kept overnight at the policy address',
    overnightVehicleAddress: {
      streetAddress: 'Street Address',
      apt: 'Apartment#',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code'
    }
  },
  isBusinessPurpose: 'Is your vehicle being used for business purposes',
  reason: 'Explanation for vehicle being used for business purposes',
  effectDate: 'What date would you like this change to go into effect?'
}

export const ADD_VEHICLE_PA_JSON_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  policyNumber: 'Policy Number',
  phoneNumber: 'Phone Number',
  streetAddress: 'Street Address',
  zipCode: 'Zip Code',
  emailAddress: 'Email Address',
  vehicleInfo: {
    vin: 'VIN',
    year: 'YEAR',
    make: 'MAKE',
    model: 'MODEL',
    purchaseDate: 'Vehicle Purchased Date',
    stateRegistered: 'Vehicle Registered State',
    registeredPersonFirstName: 'Vehicle Registered First Name',
    registeredPersonLastName: 'Vehicle Registered Last Name',
    vehicleOwnership: 'Is this vehicle owned/leased/financed',
    noOfDaysUsed: 'Number of days per week this vehicle is used to drive to work, school or public transportation site',
    oneWayMiles: 'One-way miles',
    isVehicleWithCoOwnership: 'Is there a Co-Owner/Co-Buyer/Co-Lessee',
    nameOfBank: 'Name of Bank/Leasing Company',
    coOwnershipPersonFirstName: 'Co-Owner/Co-Buyer/Co-Lessee First Name',
    coOwnershipPersonLastName: 'Co-Owner/Co-Buyer/Co-Lessee Last Name',
    otherCollisionCoverage: 'Do you choose “Other than Collision” (Comprehensive) coverage?',
    otherCollisionDeductible:
      'Choose your “Other than Collision” (Comprehensive) deductible. (The standard deductible in Pennsylvania is $500)*',
    collisionCoverage: 'Do you choose “Collision” coverage?*',
    collisionCoverageDeductible:
      'Choose your “Collision” coverage deductible. (The standard deductible in Pennsylvania is $500)*',
    rentalReimbursementCoverage: 'Do you choose Rental Reimbursement coverage?*',
    isVehiclePrimarilyKeptOvernight: 'Is this vehicle primarily kept overnight at the policy address',
    overnightVehicleAddress: {
      streetAddress: 'Street Address',
      apt: 'Apartment#',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code'
    }
  },
  isBusinessPurpose: 'Is your vehicle being used for business purposes',
  reason: 'Explanation for vehicle being used for business purposes',
  effectDate: 'What date would you like this change to go into effect?'
}
